import React from "react";

const products = [
  {
    title: "Asset Agnosticism",
    desc: "Cahex offers unparalleled flexibility, allowing businesses to transfer value seamlessly between any asset class, EVM and non-EVM chains, Bitcoin, bank accounts, and financial apps without any limitations.",
    icon: "⟳",
    color: "#52c6a8",
  },
  {
    title: "Uncompromising Security",
    desc: "Cahex stands out as the only solution that operates without intermediaries, bilateral integrations, or smart contracts, ensuring the highest level of security.",
    icon: "🔐",
    color: "#4f8ef7",
  },
  {
    title: "Built-In Regulatory Compliance",
    desc: "Cahex uniquely integrates KYT (Know Your Transaction) checks directly into its protocol, simplifying compliance with AML (Anti-Money Laundering) regulations.",
    icon: "⚖️",
    color: "#52c6a8",
  },
  {
    title: "Direct Fund Management",
    desc: "Cahex sets itself apart by directly managing funds, unlike other blockchains that rely on smart contracts. This approach offers superior efficiency and security.",
    icon: "🏦",
    color: "#4f8ef7",
  },
  {
    title: "Web2 API Integration",
    desc: "Cahex bridges the gap between traditional and decentralized applications by uniquely interacting directly with Web2 APIs.",
    icon: "🔌",
    color: "#52c6a8",
  },
];

const Product = () => {
  return (
    <section className="section px-6 py-24 max-w-7xl mx-auto">
      <div className="text-center mb-16">
        <div className="badge mb-6 inline-flex">
          <span className="badge-dot" />
          Why Choose Us
        </div>
        <h2
          className="font-syne font-bold mb-5"
          style={{ fontSize: "clamp(32px, 4vw, 54px)", color: "#e8eaf0" }}
        >
          Why Choose <span className="grad-text">CAHEX Network</span>
          <br />Over Other Solutions?
        </h2>
        <p
          className="max-w-xl mx-auto text-base"
          style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif", lineHeight: 1.7 }}
        >
          Cahex Network offers several distinct advantages that make it an ideal choice for businesses looking to integrate payments across fiat and crypto ecosystems.
        </p>
      </div>

      {/* Product cards grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">
        {products.map(({ title, desc, icon, color }, i) => (
          <div
            key={title}
            className="glow-box rounded-2xl p-6 transition-all duration-300 cursor-default"
            style={{
              background: "rgba(13,17,32,0.8)",
              gridColumn: i === 4 ? "1 / -1" : undefined,
            }}
          >
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center text-xl mb-4"
              style={{ background: `${color}15`, border: `1px solid ${color}30` }}
            >
              {icon}
            </div>
            <div className="font-syne font-semibold text-white mb-2">{title}</div>
            <div
              className="text-sm leading-relaxed"
              style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}
            >
              {desc}
            </div>
          </div>
        ))}
      </div>

      {/* Universal Payment Rail */}
      <div
        className="rounded-2xl p-8 text-center"
        style={{
          background: "linear-gradient(135deg, rgba(82,198,168,0.06), rgba(79,142,247,0.06))",
          border: "1px solid rgba(82,198,168,0.15)",
        }}
      >
        <div className="font-syne font-bold text-xl text-white mb-3">Universal Payment Rail</div>
        <p
          className="max-w-2xl mx-auto text-sm"
          style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif", lineHeight: 1.7 }}
        >
          To understand how TRON payment works, set up a TRON wallet and integrate the wallet for your TRC-20 token(s) and the Cahex SDK into your existing app to make or receive payments with USDT.
        </p>
        <div
          className="mt-6 flex justify-center gap-3 flex-wrap"
          style={{ fontFamily: "'Space Mono', monospace", fontSize: "12px" }}
        >
          {["USDT", "TRC-20", "BEP-20", "ERC-20", "Fiat"].map((t) => (
            <span
              key={t}
              className="px-3 py-1 rounded"
              style={{ background: "rgba(82,198,168,0.08)", border: "1px solid rgba(82,198,168,0.2)", color: "#52c6a8" }}
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Product;
